<template>
  <div class="card ml-md-3">
    <div class="card-body">
      <b-overlay :show="apiLoading" spinner-variant="primary" blur=".3" opacity=".75" rounded="sm">
        <validation-observer ref="ProfileDetails">
          <b-form @submit.prevent="onSubmit">
            <div class="row justify-content-center w-100">
              <div class="col-md-6">
                <validation-provider #default="{ errors }" name="First name" rules="required">
                  <b-form-group
                    class="align-items-center"
                    label="First name"
                    label-for="first-name"
                    label-class="font-weight-bold"
                  >
                    <b-form-input id="first-name" v-model="form.first_name" :state="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="col-md-6">
                <validation-provider #default="{ errors }" name="Last name" rules="required">
                  <b-form-group
                    class="align-items-center"
                    label="Last name"
                    label-for="last-name"
                    label-class="font-weight-bold"
                  >
                    <b-form-input id="last-name" v-model="form.last_name" :state="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
              <!-- EMAIL -->
              <div class="col-md-12">
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                  <b-form-group
                    class="align-items-center"
                    label="Email"
                    label-for="email"
                    label-class="font-weight-bold"
                  >
                    <b-form-input id="email" v-model="form.email" disabled :state="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <!-- PHONE NUMBER -->
              <div class="col-md-12">
                <validation-provider #default="{ errors }" name="Phone Number" rules="required">
                  <b-form-group
                    class="align-items-center"
                    label="Phone Number"
                    label-for="phone-number"
                    label-class="font-weight-bold"
                  >
                    <PhoneInput :phone-code="customerPhoneCode" v-model="form.phone_number" :errors="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <div class="col-md-12">
                <h4 class="mb-4">Change Password</h4>
              </div>

              <!-- OLD PASSWORD -->
              <div class="col-md-12">
                <validation-provider
                  #default="{ errors }"
                  name="Old Password"
                  rules="required_if:password"
                  vid="old-password"
                >
                  <b-form-group
                    class="align-items-center"
                    label="Old Password"
                    label-for="old-password"
                    label-class="font-weight-bold"
                  >
                    <b-form-input
                      id="old-password"
                      v-model="form.old_password"
                      type="password"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <!-- PASSWORD -->
              <div class="col-md-12">
                <validation-provider #default="{ errors }" name="Password" rules="" vid="password">
                  <b-form-group
                    class="align-items-center"
                    label="Password"
                    label-for="password"
                    label-class="font-weight-bold"
                  >
                    <b-form-input
                      id="password"
                      type="password"
                      v-model="form.password"
                      autocomplete="new-password"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <!-- CONFIRM PASSWORD -->
              <div class="col-md-12">
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required_if:password|confirmed:password"
                >
                  <b-form-group
                    class="align-items-center"
                    label="Confirm Password"
                    label-for="confirm_password"
                    label-class="font-weight-bold"
                  >
                    <b-form-input
                      id="confirm_password"
                      type="password"
                      v-model="form.confirm_password"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <!-- CONTROL -->
              <div class="col-md-12 d-flex flex-column flex-md-row gap-8 justify-content-start">
                <b-button variant="primary" type="submit">Update Profile</b-button>
                <b-button @click="onCancel" class="rounded-btn" variant="outline-primary">Cancel</b-button>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ApiMixin from "@core/mixin/ApiMixin"
import PhoneInput from "@core/components/PhoneInput.vue"

export default {
  name: "ProfileDetails",
  mixins: [ApiMixin],
  props: ["customerId", "customerEmail", "customerPhone", "customerPhoneCode", "customerFirstName", "customerLastName"],
  components: { PhoneInput },
  data() {
    return {
      form: {
        first_name: this.customerFirstName,
        last_name: this.customerLastName,
        email: this.customerEmail,
        phone_number: this.customerPhone,
        old_password: "",
        password: "",
        confirm_password: ""
      }
    }
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      this.$refs.ProfileDetails.validate().then(success => {
        if (success) {
          const formData = {
            first_name: this.form.first_name,
            last_name: this.form.last_name,
            phone_number: this.form.phone_number.formattedNumber,
            code: this.form.phone_number.countryCode,
            old_password: undefined,
            password: undefined,
            confirm_password: undefined
          }
          if (this.form.password) {
            formData.old_password = this.form.old_password
            formData.password = this.form.password
            formData.password_confirmation = this.form.confirm_password
          }
          this.put("/account/profile", formData, true).then(res => {
            this.resetPassword()
          })
        }
      })
    },
    resetPassword() {
      this.form.password = ""
      this.form.confirm_password = ""
    },
    onCancel() {
      this.form.first_name = this.customerFirstName
      this.form.last_name = this.customerLastName
      this.form.email = this.customerEmail
      this.form.phone_number = this.customerPhone
      this.form.old_password = ""
      this.resetPassword()
    }
  }
}
</script>

<style lang="scss">
.rounded-btn {
  border-radius: 0.25rem;
}
</style>
